import { DialogService } from 'aurelia-dialog';
import { Container } from 'aurelia-framework';
import { UniversalEntitySelect } from '../../../dialog/universal-entity-select';

let dialogService = Container.instance.get(DialogService);

export default function (editor) {
    editor.on('asset:open', () => {
        const amContainer = document.querySelector('.gjs-am-assets-cont');
        if (amContainer) {
            const existingButton = document.querySelector(
                '.custom-select-image-button'
            );
            if (existingButton) {
                existingButton.remove();
            }

            const button = document.createElement('button');
            button.innerText = 'Medien aus der Medienbibliothek auswählen';
            button.className = 'custom-select-image-button gjs-btn-prim';
            button.style.margin = '10px';
            button.addEventListener('click', () => {
                const selectedBlock = editor.getSelected();
                let conditions = {};
                if (selectedBlock) {
                    const blockType = selectedBlock.get('type');
                    if (blockType === 'bs-image' || blockType === 'gallery-image' || blockType === 'image-box') {
                        conditions = {
                            type: { $in: ['image'] },
                        };
                    } else if (blockType === 'video') {
                        conditions = {
                            type: { $in: ['video'] },
                        };
                    }
                }
                dialogService
                    .open({
                        viewModel: UniversalEntitySelect,
                        model: {
                            selectModelId: 'media-database/media-item',
                            // multiSelect: multiple,
                            conditions: conditions, // Pass the dynamically set conditions here
                        },
                    })
                    .whenClosed((data) => {
                        const items = data.output;
                        if (!items || items.length === 0) {
                            return null;
                        }
                        const blockType = selectedBlock?.get?.('type');
                        const isImageBlock =
                            blockType === 'bs-image' || blockType === 'gallery-image';
                        const isImageBox = blockType === 'image-box';

                        if ((isImageBlock || isImageBox) && selectedBlock) {
                            const item = items[0];
                            const src = item?.file?.previewUrl
                                ? item.file.previewUrl
                                    .replace('$width', '1500')
                                    .replace('$height', '-')
                                : item.file.downloadUrl;
                            if (isImageBox) {
                                selectedBlock.set('background-image', src);
                                selectedBlock.trigger('change:background-image');
                            } else {
                                selectedBlock.addAttributes({
                                    src,
                                    alt: item?.alt ?? '',
                                    title: item?.title ?? '',
                                });
                                selectedBlock.trigger('change:attributes');
                            }
                            editor.AssetManager.close();
                        } else {
                            for (const item of items) {
                                editor.AssetManager.add({
                                    src: item?.file?.previewUrl
                                        ? item.file.previewUrl
                                            .replace('$width', '1500')
                                            .replace('$height', '-')
                                        : item.file.downloadUrl,
                                    name: item?.title,
                                    title: item?.title,
                                    alt: item?.alt,
                                });
                            }
                        }
                    });
            });
            amContainer.prepend(button);
        }
    });

    function getHighlightedAssetMeta() {
        const asset = document.querySelector('.gjs-am-asset.gjs-am-highlight');
        if (!asset) return null;

        const titleEl = asset.querySelector('.gjs-am-name');
        const preview = asset.querySelector('.gjs-am-preview');

        const title = titleEl?.textContent?.trim() || null;

        let src = null;
        let alt = null;

        if (preview) {
            const style = preview.style.backgroundImage;
            const match = style.match(/url\(["']?(.*?)["']?\)/);

            if (match) {
                src = match[1];
                const filename = src.split('/').pop().split('?')[0];
                alt = decodeURIComponent(filename);
            }
        }

        return { title, alt, src };
    }


    const handleAssetSelect = () => {
        const selectedComponent = editor.getSelected();
        if (!selectedComponent) return;

        const componentType = selectedComponent.get?.('type');
        const isImageBlock =
            componentType === 'bs-image' || componentType === 'gallery-image';
        const isImageBox = componentType === 'image-box';

        if (!isImageBlock && !isImageBox) return;

        const assets = editor.AssetManager.getAll();
        const src = getHighlightedAssetMeta()?.src;
        if (!src) return;

        const selectedAsset = assets?.models?.find((asset) => asset.id === src)?.attributes;
        if (!selectedAsset?.title && !selectedAsset?.src) return;

        if (isImageBox) {
            selectedComponent.set('background-image', src);
            selectedComponent.trigger('change:background-image');
        } else {
            selectedComponent.addAttributes({
                src,
                alt: selectedAsset?.alt || '',
                title: selectedAsset?.title || '',
            });
            selectedComponent.trigger('change:attributes');
        }
    };

    editor.on('asset:close', handleAssetSelect);

}
